import React from 'react';
import classNames from 'classnames';

import propTypes from 'propTypes';
import PriceSpan from 'common/components/formatters/PriceSpan';

export default class VariantPrice extends React.Component {
  static propTypes = {
    baseAmount: propTypes.number.isRequired,
    isMembershipOrder: propTypes.bool.isRequired,
    membershipDiscountRate: propTypes.number.isRequired,
    isSubscribable: propTypes.bool.isRequired,
    commitmentMonths: propTypes.number,
    commitmentPrice: propTypes.number,
    exemptedUser: propTypes.bool.isRequired,
    userAmount: propTypes.number.isRequired,
  };

  get isSpecialPrice() {
    return (
      this.isMembershipPrice || this.props.baseAmount != this.props.userAmount
    );
  }

  get isMembershipPrice() {
    const {
      exemptedUser,
      isSubscribable,
      isMembershipOrder,
      commitmentMonths,
    } = this.props;
    const isSubscribableInMembershipOrder = isSubscribable && isMembershipOrder;
    return (
      isSubscribableInMembershipOrder && !(commitmentMonths && exemptedUser)
    );
  }

  get formattedPrice() {
    const { priceUnitString, commitmentPrice } = this.props;

    const displayUnitString =
      commitmentPrice && priceUnitString ? `/${priceUnitString}` : '';

    return (
      <span>
        <PriceSpan
          className={classNames({ gold: this.isSpecialPrice })}
          amount={this.amount}
        />
        <span className={classNames('text--small')}>{displayUnitString}</span>
      </span>
    );
  }

  get amount() {
    const { membershipDiscountRate, userAmount } = this.props;
    return this.isMembershipPrice
      ? userAmount * (1 - membershipDiscountRate)
      : userAmount;
  }

  get isFree() {
    return (
      this.props.commitmentMonths &&
      this.props.commitmentPrice === 0 &&
      !this.props.exemptedUser
    );
  }

  get displayPrice() {
    return this.isFree ? null : this.formattedPrice;
  }

  render() {
    return (
      <span className={classNames({ gold: this.isSpecialPrice })}>
        {this.displayPrice}
      </span>
    );
  }
}



// WEBPACK FOOTER //
// ./app/javascript/apps/cart/components/VariantPrice.js